const checkMessage = (setMessage: React.Dispatch<null | string>, type: null | string) => <T extends {}>(data: T) => {
  const message = type === 'profile' ? 'Profile updated successfully' : 'Notification preferences updated successfully.';
  setMessage(data ? message : null);
}
export default checkMessage;
